import Immutable from 'seamless-immutable';
import { createActions, createReducer } from 'reduxsauce';

const INITIAL_STATE = Immutable({
  categories: [],
});
export const NewsSelectors = {};

/* ------------- Types and Action Creators ------------- */
export const { Types: NewsActionsType, Creators: NewsActions } = createActions({
  setCategories: ['categories'],
});

const setCategories = (state, { categories }) => {
  return state.merge({
    categories,
  });
};

const HANDLERS = {
  [NewsActionsType.SET_CATEGORIES]: setCategories,
};

export default createReducer(INITIAL_STATE, HANDLERS);
